import React from "react";

/**
 * Wraps content that is being replaced by a newer fetch.
 *
 * Keeps the current rows readable and dims them, rather than swapping them for a
 * placeholder. A list that blanks on every sort or page click reads as slower than
 * it is, and loses the user's place: what they were looking at disappears and comes
 * back somewhere else.
 *
 * Only for refreshes. The first load has nothing to keep, so pages should still
 * render their own placeholder while `initialLoading` is true.
 */
export default function Refreshing({ active, children }) {
  return (
    <div style={{ position: "relative" }}>
      {active && (
        <div
          aria-hidden
          style={{
            position: "absolute", top: 0, left: 0, right: 0, height: 2,
            overflow: "hidden", borderRadius: 2, zIndex: 2,
          }}>
          <div style={{
            height: "100%", width: "40%", background: "#E8431A", borderRadius: 2,
            animation: "compass-refresh 1s ease-in-out infinite",
          }} />
        </div>
      )}
      <style>{`
        @keyframes compass-refresh {
          0%   { transform: translateX(-100%) }
          100% { transform: translateX(350%) }
        }
      `}</style>
      <div
        aria-busy={active || undefined}
        style={{
          opacity: active ? 0.45 : 1,
          // Blocks clicks on rows that are about to be replaced — acting on a row
          // that is mid-swap applies the action to whatever lands in its place.
          pointerEvents: active ? "none" : "auto",
          transition: "opacity 120ms ease",
        }}>
        {children}
      </div>
    </div>
  );
}
